import PropTypes from 'prop-types';
import React from 'react';

import EditButton from '@/features/productsPage/Page/Row/Actions/EditButton';

const Actions = ({ classes, productId }) => (
  <div className={classes.root}>
    <EditButton
      productId={productId}
      small={false}
      color="primary"
      variant="contained"
    />
  </div>
);

Actions.propTypes = {
  productId: PropTypes.number.isRequired,
};

export default Actions;
